module.exports = __webpack_public_path__ + "img/classiccar-2.521413f5.webp";